import { render, staticRenderFns } from "./CreditsDisplay.vue?vue&type=template&id=5f15ce42&scoped=true"
import script from "./CreditsDisplay.vue?vue&type=script&lang=js"
export * from "./CreditsDisplay.vue?vue&type=script&lang=js"
import style0 from "./CreditsDisplay.vue?vue&type=style&index=0&id=5f15ce42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f15ce42",
  null
  
)

export default component.exports